import styled from 'styled-components';

export const Container = styled.div`
  form {
    width: 100%;

    .inputContainer {
      background: #ffffff;
      color: #666360;

      height: 48px;
      border-radius: 10px;

      width: 100%;
      display: flex;
      align-items: center;
    }

    label[for='code_order_recharge'] {
      font-size: 18px;
    }

    .buttonsContainer {
      display: flex;
      justify-content: flex-end;
    }
  }
`;

export const FormWrapper = styled.div`
  width: 100%;
  Form {
    margin-top: 20px;
  }

  input {
    height: 40px;
  }
  .btn-wrapper {
    margin-top: 30px;
    display: flex;
    width: 100%;
    button {
      width: inherit;
    }

    .btn-cancelar {
      color: #757575;
      background-color: #fff;
      border: 1px solid #e8e8e8;
      margin-right: 20px;
    }
  }
  .bloqueados {
    margin-bottom: 60px;
  }
`;

export const ModalContent = styled.div`
  height: 250px;
  width: 600px;
  padding: 0px 15px 30px 15px;
  text-align: center;
  p {
    padding-bottom: 10px;
  }
`;

export const LinkModal = styled.a`
  text-decoration: underline;
  color: var(--purple) !important;
  width: 50px;
  height: auto;
  cursor: pointer;
  :hover {
    color: var(--orange);
  }
  padding-right: 5px;
`;
